/**
 * OrbDocTutorialsAdvancedAiGenerationENOrbDocTutorialsAdvancedAiGenerationENPage
 *
 * Page component for OrbDocTutorialsAdvancedAiGenerationENOrbDocTutorialsAdvancedAiGenerationENPage
 * Path: /docs/tutorials/advanced/ai-generation
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocTutorialsAdvancedAiGenerationENDocScreenView as __OrbDocTutorialsAdvancedAiGenerationENDocScreenView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationENDocScreenView';
import { OrbDocTutorialsAdvancedAiGenerationENDocAnalyticsView as __OrbDocTutorialsAdvancedAiGenerationENDocAnalyticsView } from '@/components/traits/OrbDocTutorialsAdvancedAiGenerationENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocTutorialsAdvancedAiGenerationENOrbDocTutorialsAdvancedAiGenerationENPageProps {
  // Add any page-level props here
}

export function OrbDocTutorialsAdvancedAiGenerationENOrbDocTutorialsAdvancedAiGenerationENPage(_props: OrbDocTutorialsAdvancedAiGenerationENOrbDocTutorialsAdvancedAiGenerationENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"Generating programs with AI","description":"Describe an app in words and let the orb agent write the program, with the compiler checking every step.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/tutorials/advanced/ai-generation"},{"locale":"ar","path":"/ar/docs/tutorials/advanced/ai-generation"},{"locale":"sl","path":"/sl/docs/tutorials/advanced/ai-generation"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocTutorialsAdvancedAiGenerationENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocTutorialsAdvancedAiGenerationENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocTutorialsAdvancedAiGenerationENOrbDocTutorialsAdvancedAiGenerationENPage;
